import { getConfig } from "../config/config";
import {
  listRemoteKeys,
  mapRemoteKeys,
  MF_REMOTES,
  type RemoteUrlKey
} from "../config/mfRemotes";

export type RemoteId = RemoteUrlKey;

export const RemoteId: { [K in RemoteId]: K } = mapRemoteKeys((key) => key);

export interface RemoteDefinition {
  id: RemoteId;
  federationName: string;
  module: string;
  getRemoteEntryUrl: () => string;
}

export function getRemoteDefinition(remoteId: RemoteId): RemoteDefinition {
  if (!(remoteId in MF_REMOTES)) {
    throw new Error(`Unknown remote id: ${remoteId}`);
  }

  const spec = MF_REMOTES[remoteId];

  return {
    id: remoteId,
    federationName: spec.federationName,
    module: spec.module,
    getRemoteEntryUrl: () => getConfig().remotes[remoteId]
  };
}

export function listRemoteDefinitions(): RemoteDefinition[] {
  return listRemoteKeys().map(getRemoteDefinition);
}
